import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  decor?: string;
  text: string;
};

const Wrap = styled.div`
  && {
    background-color: rgba(236, 255, 184, 1);
    display: flex;
    align-items: center;
    height: 66px;
  }
`;
const HeaderMini: FC<Props> = ({ children, text, decor }) => {
  return (
    <Wrap className={decor}>
      <p className="mb-0 largeBoldFont">{text}</p>
      <div>{children}</div>
    </Wrap>
  );
};

export default HeaderMini;
